<template>
  <div class="container">
    <div class="top">
      <img src="@/assets/img/kept_logo_2.svg" alt="Kept" class="logo"/>
      <div class="header">
        <TopTypeSelector/>
        <Filter :groups="groups" :active-group="activeGroup" :types="types" :active-type="activeType"
                :report-dates="reportDates" :active-report-date="activeReportDate" :statuses="statuses"
                :active-status="activeStatus" :currencies="currencies" :active-currency="activeCurrency"
                @apply-group="applyGroup" @apply-type="applyType" @apply-report-date="applyReportDate"
                @apply-status="applyStatus" @apply-currency="applyCurrency" @clear-all="clearAll"/>
        <div class="buttons">
          <div v-if="hasPerm('draft') || hasPerm('pending_approval')">
            <router-link to="/upload">Загрузить данные&nbsp;</router-link>
          </div>
          <div v-if="hasPerm('draft') || hasPerm('pending_approval')" :class="isDisabledDeleteOrCalculate" test-id="delete_button_div">
            <a @click="getReportsForDelete" test-id="delete_reports_button">Удалить данные&nbsp;</a>
          </div>
          <div :class="isDisabledDeleteOrCalculate">
            <a @click="recalculateReports">Рассчитать&nbsp;</a>
          </div>
          <div v-if="hasPerm('validate')" :class="isDisabledValidate">
            <a @click="process('validate')">Отправить на проверку&nbsp;</a>
          </div>
          <div v-if="hasPerm('approve')" :class="isDisabledApprove">
            <a @click="process('approve')">Утвердить&nbsp;</a>
          </div>
          <div v-if="hasPerm('deny')" :class="isDisabledDeny">
            <a @click="process('deny')">Отклонить утверждение&nbsp;</a>
          </div>
          <div v-if="hasPerm('unlock')" :class="isDisabledUnlock">
            <a @click="process('unlock')">Разблокировать расчет&nbsp;</a>
          </div>
        </div>
      </div>
    </div>

    <div class="content">
      <LeftTypeSelector/>
      <div class="reports" :key="reload">
        <Grid :title="'Наилучшие оценки'" :items="activeItems([101, 106, 107, 108, 109, 110, 111, 112, 113])"
              @change-state="changeRowState" @change-grid="changeGridState"/>
        <Grid :title="'Рисковые поправки'" :items="activeItems([102, 114])" @change-state="changeRowState" @change-grid="changeGridState"/>
        <Grid :title="'Денежные потоки'" :items="activeItems([103, 104, 116, 117, 127, 128, 129, 130])"
              @change-state="changeRowState" @change-grid="changeGridState"/>
        <Grid :title="'Перестрахование'" :items="activeItems([120, 121, 122, 123, 124, 125, 126])"
              @change-state="changeRowState" @change-grid="changeGridState"/>
        <Grid :title="'Прочие потоки'" :items="activeItems([118, 119, 131, 132, 133, 134])"
              @change-state="changeRowState" @change-grid="changeGridState"/>
      </div>
    </div>
    <div class="loading" v-show="loading">
      <img src="@/assets/img/loading.svg" alt="" srcset="">
    </div>
  </div>

  <teleport to="body">
    <Modal :show="showDeleteInfoModal" :controlsAvaliable="!deleteReportsStarted">
      <template v-if="deleteError" #header>
        <div class="modal-header">Возникла ошибка!</div>
      </template>
      <template v-if="deleteReportsStarted" #header>
        <div class="modal-header">Идет удаление расчетов</div>
      </template>
      <template v-else #header>
        <div class="modal-header">Будут удалены все следующие расчеты. Вы уверены?</div>
      </template>
      <template #body v-if="deleteError">
        {{ deleteError }}
      </template>
      <template #body v-else-if="deleteReportsStarted">
        Пожалуйста, подождите
      </template>
      <template #body v-else>
        Это действие нельзя отменить
        <ul>
          <li v-for="report in reportsToDelete" v-bind:key="report.id">
            {{ report.name }}
          </li>
        </ul>
      </template>
      <template #footer v-if="deleteError">
        <button @click="switchDeleteInfoModalState">Ок</button>
      </template>
      <template #footer v-else>
        <button @click="deleteReports" test-id="delete_button">Удалить</button>
        <button @click="switchDeleteInfoModalState" test-id="cancel_button">Отмена</button>
      </template>
    </Modal>
  </teleport>

    <teleport to="body">
      <Modal :show="showRecalculateInfoModal" :controlsAvaliable="!recalculateReportsStarted">
        <template #header>
          <div class="modal-header">
            Расчет
          </div>
        </template>

        <template #body v-if="recalculateReportsStarted">
          Производится расчет. Не покидайте страницу
          <br>
          Выполнено {{ recalcualatedReportsCount }} из {{ reportsToRecalculateCount }}
        </template>
        
        <template #body v-else>
          Расчет был завершен!
        </template>

        <template #footer v-if="recalculateReportsStarted"></template>
        <template #footer v-else>
          <button @click="switchRecalculateInfoModalState">Ок</button>
        </template>
    </Modal>
  </teleport>
</template>

<script>
import TopTypeSelector from '@/components/TopTypeSelector'
import Filter from '@/components/Dashboard/Filter'
import LeftTypeSelector from '@/components/LeftTypeSelector'
import Grid from '@/components/Dashboard/Grid'
import Modal from '@/components/Modal'

export default {
  name: 'Dashboard',
  components: {
    TopTypeSelector,
    Filter,
    LeftTypeSelector,
    Grid,
    Modal
  },
  data() {
    return {
      polling: null,
      items: [],
      groups: Object,
      activeGroup: 0,
      types: Object,
      activeType: 0,
      reportDates: Object,
      activeReportDate: '1900-01-01',
      statuses: Object,
      activeStatus: 0,
      currencies: Object,
      activeCurrency: 0,
      reload: 0,
      loading: false,
      showDeleteInfoModal: false,
      reportsToDelete: [],
      deleteError: null,
      deleteReportsStarted: false,
      showRecalculateInfoModal: false,
      recalculateReportsStarted: false,
      recalculateSelectedTaskId: null,
      recalcualatedReportsCount: 0,
      reportsToRecalculateCount: 0,
      recalculateStatusUpdateInterval: null,
    }
  },
  computed: {
    isDisabledValidate() {
      const found = this.items.filter(i => i.isChecked).map(i => i.status)
      const status = (element) => element !== 101;

      if (!found.some(status) && this.items.filter(i => i.isChecked).length !== 0) {
        return ''
      } else {
        return 'disabled'
      }

    },
    isDisabledApprove() {
      return this.getDisabledByStatuses([101, 201])
    },
    isDisabledDeny() {
      return this.getDisabledByStatuses([201])
    },
    isDisabledUnlock() {
      return this.getDisabledByStatuses([301])
    },
    isDisabledDeleteOrCalculate() {
      return this.items.filter(i => i.isChecked).length !== 0 ? '' :'disabled'
    },
  },
  methods: {
    switchDeleteInfoModalState(){
      this.showDeleteInfoModal = !this.showDeleteInfoModal;
      if(!this.showDeleteInfoModal){
        this.reportsToDelete = []
        this.deleteError = null
      }
    },
    switchRecalculateInfoModalState(){
      this.showRecalculateInfoModal = !this.showRecalculateInfoModal;
    },
    getDisabledByStatuses(statuses){
      const found = this.items.filter(i => i.isChecked).map(i => i.status)
      const disabled = found.every(elem => statuses.includes(elem)) && this.items.filter(i => i.isChecked).length !== 0
      return disabled ? '' : 'disabled'
    },
    hasPerm(permission) {
      return window.drfUser.permissions.includes('api.' + permission)
    },
    activeItems(types) {
      return this.items.filter(i =>
          (this.activeGroup === 0 || i['group'] === this.activeGroup) &&
          (this.activeType === 0 || i['type'] === this.activeType) && (types.includes(i['type'])) &&
          (this.activeReportDate === '1900-01-01' || i['report_date'] === this.activeReportDate) &&
          (this.activeStatus === 0 || i['status'] === this.activeStatus) &&
          (this.activeCurrency === 0 || i['currency'] === this.activeCurrency))
    },
    createMap(key, value, defaultValue) {
      const map = new Map()
      map.set(defaultValue, '-')
      this.items.forEach(i => map.set(i[key], i[value]))
      return map
    },
    applyGroup(group) {
      this.activeGroup = Number(group)
      this.clearRowsState()
    },
    applyType(type) {
      this.activeType = Number(type)
      this.clearRowsState()
    },
    applyReportDate(date) {
      this.activeReportDate = date
      this.clearRowsState()
    },
    applyStatus(status) {
      this.activeStatus = Number(status)
      this.clearRowsState()
    },
    applyCurrency(currency) {
      this.activeCurrency = Number(currency)
      this.clearRowsState()
    },
    clearAll() {
      this.activeGroup = 0
      this.activeType = 0
      this.activeReportDate = '1900-01-01'
      this.activeStatus = 0
      this.activeCurrency = 0
      this.clearRowsState()
    },
    changeRowState(id) {
      const found = this.items.filter(i => i.id === id)
      if (found.length === 1) {
        found[0].isChecked = !found[0].isChecked
      }
    },
    clearRowsState() {
      this.items.forEach(i => i.isChecked = false)
      this.reload++
    },
    loadReports() {
      this.loading = true
      this.$http
          .get('/reports')
          .then(response => {
            this.items = response.data.filter(i => i.type !== 105)
            this.items.forEach(i => i.isChecked = false)
            
            this.groups = this.createMap('group', 'group_name', 0)
            this.types = this.createMap('type', 'type_name', 0)
            this.reportDates = this.createMap('report_date', 'report_date', '1900-01-01')
            this.statuses = this.createMap('status', 'status_name', 0)
            this.currencies = this.createMap('currency', 'currency_name', 0)
            console.log('Dashboard->mounted(): data is loaded')
          })
          .catch(error => console.error('Dashboard->mounted(): ERROR: ' + error))
          .finally(()=>{this.loading = false})
    },
    process(action) {
      const found = this.items.filter(i => i.isChecked).map(i => i.id)
      if (!found.length) {
        return
      }

      this.$http.post('/reports/process', {'action': action, 'ids': found})
          .then(response => {
            console.log(`Dashboard->process('${action}'): ${response.data.info}`)
          })
          .catch(error => {
            console.error(`Dashboard->process('${action}'): ERROR: ${error}`)
          })
          .finally(() => {
            this.loadReports()
            this.reload++
          })
    },
    getReportsForDelete() {
      const found = this.items.filter(i => i.isChecked).map(i => i.id)
      if (!found.length) {
        return
      }
      this.$http
        .post('/reports/related/', {'ids': found})
        .then(response => {
          this.reportsToDelete = response.data
          this.switchDeleteInfoModalState()
        })
        .catch(error => {
          console.error(`Dashboard->getRelatedReports: ERROR: ${error}`)
          this.deleteError = error.response.data
          this.switchDeleteInfoModalState()
        })
    },
    deleteReports(action) {
      const found = this.reportsToDelete.map(i => i.id)
      if (!found.length) {
        return
      }
      
      this.deleteReportsStarted = true;
      this.$http.post('/reports/delete/', {'ids': found})
        .then(response => {
          console.log(`Dashboard->process('${action}'): ${response.data.info}`)
        })
        .catch(error => {
          console.error(`Dashboard->process('${action}'): ERROR: ${error}`)
        })
        .finally(() => {
          this.loadReports()
          this.reload++
          this.reportsToDelete = []
          this.deleteReportsStarted = false;
          this.switchDeleteInfoModalState()
        })
    },
    recalculateReports() {
      this.recalculateReportsStarted = true
      this.switchRecalculateInfoModalState()

      const found = this.items.filter(i => i.isChecked).map(i => i.id)
      if (!found.length) {
        return
      }
      
      this.$http.post('/reports/recalculate-selected', {'ids': found})
        .then(response => {
          console.log(`Dashboard->process('Recalculate Reports'): ${response.data.info}`)

          this.recalculateSelectedTaskId = response.data.id
          
          this.recalcualatedReportsCount = 0
          this.reportsToRecalculateCount = 0
          this.startRecalculateStatusUpdateInterval()
        })
        .catch(error => {
          this.loadReports()
          this.recalculateReportsStarted = false
          console.error(`Dashboard->process('Recalculate Reports'): ERROR: ${error}`)
        })
    },
    startRecalculateStatusUpdateInterval(){
      this.recalculateStatusUpdateInterval = setInterval(()=>{
        this.getRecalculateStatus()
      }, 1000)
    },
    stopRecalculateStatusUpdateInterval(){
      clearInterval(this.recalculateStatusUpdateInterval)
    },
    getRecalculateStatus(){
      this.$http.get(`/reports/recalculate-selected?task_id=${this.recalculateSelectedTaskId}`)
        .then(response => {
          console.log(`Dashboard->process('Recalculate Reports'): ${response.data.info}`)

          const taskInfo = response.data

          if(!taskInfo.completed){
            this.recalcualatedReportsCount = taskInfo.processed_reports
            this.reportsToRecalculateCount = taskInfo.reports_count
          }else{
            this.loadReports()
            this.recalculateReportsStarted = false
            this.stopRecalculateStatusUpdateInterval()
          }
        })
        .catch(error => {
          console.error(`Dashboard->process('Recalculate Reports'): ERROR: ${error}`)
        })
    },
    pollData() {
      if (!this.polling) {
        this.polling = setInterval(() => {
          this.loadReports()
        }, 10000)
      }
    },
    getURL() {
      const urlDashboard = new URLSearchParams(window.location.search);
      const urlReportDate = urlDashboard.get('report-date');
      if (urlReportDate !== null) {
        this.activeReportDate = urlReportDate;
        this.activeStatus = 301;
      }

    },
    changeGridState(ids, checked) {
      const reports = this.items.filter(i => ids.includes(i.id))
      reports.forEach((report) => {
        report.isChecked = checked
      })
    },
  },
  mounted() {
    this.loadReports();
    this.getURL()

    // this.pollData()
  },
  unmounted() {
    clearInterval(this.polling)
  }
}
</script>

<style scoped>
.top {
  display: flex;
  align-items: center;
  background-color: #feffff;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.15);
  padding-top: 1rem;
  width: 100%;
  height: 13rem;
  position: fixed;
  z-index: 1000;
  margin: 0;
  top: 0;
}

.logo {
  margin-left: 2rem;
}

.header {
  position: fixed;
  left: 16rem;
  top: 0;
  width: calc(100% - 17rem);
}

.buttons {
  display: flex;
  padding-bottom: 1rem;
  align-items: start;
}

.buttons div {
  padding: 0.5rem;
  border-bottom: 2px solid #3ebaff;
}

.buttons a {
  text-decoration: none;
  text-transform: uppercase;
  cursor: pointer;
  color: #3ebaff;
  white-space: nowrap;
  font-size: 0.95rem;
}

.buttons a:after {
  content: url('@/assets/img/indicator_active.svg');
}

.buttons div.disabled {
  border-bottom: 1px solid #6b6f77;
}

.buttons div.disabled a {
  color: #6b6f77;
}

.buttons div.disabled a:after {
  content: url('@/assets/img/indicator_no_active.svg');
}

.content {
  display: flex;
  background-color: #feffff;
  margin-top: 13rem;
}

.reports {
  padding: 1rem;
  background-color: #efeeee;
  margin-left: 15rem;
  width: 100%;
}

.loading{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);

  display: flex;
  justify-content: center;
  align-items: center;
}

.loading img{
  width: 3rem;
}
</style>
